import React, { Fragment } from 'react';
import Stepper from 'components/shared/Stepper';
import { ProgressIndicator } from 'components/shared/Progress';

function CommissionPanel({ value, error, loading, children }) {
  return (
    <Stepper.Panel value={value}>
      {loading ? (
        <ProgressIndicator />
      ) : error != null ? (
        <Fragment>
          <h4>{error.name}</h4>
          <p>{error.message}</p>
        </Fragment>
      ) : (
        children
      )}
    </Stepper.Panel>
  );
}

export default CommissionPanel;
